import $ from 'jquery';
import moment from 'moment';
import * as DateRangePicker from 'daterangepicker';
moment.locale('th');

$.fn.daterangepicker = function(options, callback) {
  var implementOptions = $.extend(true, {}, $.fn.daterangepicker.defaultOptions, options);
  this.each(function() {
      var el = $(this);
      if (el.data('daterangepicker'))
          el.data('daterangepicker').remove();
      el.data('daterangepicker', new DateRangePicker(el, implementOptions, callback));
  });
  return this;
};

$(document).ready(function(){
  
  if ( $('.wow-form-package-tour-a__form').length <= 0 ) return
  
  const setDatePickerValue = function () {
    const inputSelector = '.js-form-package-daterangepicker-pickdate'
    const $inputDateRange = $(inputSelector);
    const picker = $inputDateRange.data('daterangepicker');
    $inputDateRange.val(picker.startDate.format('DD MMM YYYY') + ' - ' + picker.endDate.format('DD MMM YYYY'));
    const $form = $(inputSelector).parents('form');
    $form.find('input[name="start_date"]').val(picker.startDate.format('DD MMM YYYY'));
    $form.find('input[name="end_date"]').val(picker.endDate.format('DD MMM YYYY'));
    if($inputDateRange.val()){
      $('.js-form-package-daterangepicker-pickdate-clear').show();
    }else{
      $('.js-form-package-daterangepicker-pickdate-clear').hide();
    }
  };

  $('.js-form-package-daterangepicker-pickdate').daterangepicker({
    autoApply: true,
    autoUpdateInput: false,
    firstDay: 1,
    opens: 'center',
  }, function(start, end, label) {
    setDatePickerValue()
  })
  .on('hide.daterangepicker', (e, picker) => {
    if(!$(e.target).val()){
      picker.startDate = moment();
      picker.endDate = moment();
      $('.js-form-package-daterangepicker-pickdate-clear').hide();
    }else{
      setDatePickerValue();
    }
  });
  $('.js-form-package-daterangepicker-pickdate-clear').click(function(){
    const $inputDateRange = $('.js-form-package-daterangepicker-pickdate');
    const picker = $inputDateRange.data('daterangepicker');
    $inputDateRange.val('');
      $inputDateRange.trigger('hide.daterangepicker', picker);
  });
})

